__turbopack_context__.v({
  "aboutUsButtonRow": "btjmLq_aboutUsButtonRow",
  "aboutUsContainer": "btjmLq_aboutUsContainer",
  "aboutUsImage": "btjmLq_aboutUsImage",
  "aboutUsParagraphs": "btjmLq_aboutUsParagraphs",
  "aboutUsText": "btjmLq_aboutUsText",
  "aboutUsTitle": "btjmLq_aboutUsTitle",
  "active": "btjmLq_active",
  "adaptiveFlexAlign": "btjmLq_adaptiveFlexAlign",
  "adaptiveSectionElevenTextAlign": "btjmLq_adaptiveSectionElevenTextAlign",
  "adaptiveSectionSixTextAlign": "btjmLq_adaptiveSectionSixTextAlign",
  "adaptiveTextAlign": "btjmLq_adaptiveTextAlign",
  "adaptiveTitleSize": "btjmLq_adaptiveTitleSize",
  "advantageCardsContainer": "btjmLq_advantageCardsContainer",
  "advisorGrid": "btjmLq_advisorGrid",
  "advisorSection": "btjmLq_advisorSection",
  "arrowDown": "btjmLq_arrowDown",
  "arrowRight": "btjmLq_arrowRight",
  "awardContainer": "btjmLq_awardContainer",
  "awardImageContainer": "btjmLq_awardImageContainer",
  "awardName": "btjmLq_awardName",
  "awardPrice": "btjmLq_awardPrice",
  "beforeAfterLabel": "btjmLq_beforeAfterLabel",
  "bigRow": "btjmLq_bigRow",
  "box": "btjmLq_box",
  "certIconGroup": "btjmLq_certIconGroup",
  "certText": "btjmLq_certText",
  "certificationBanner": "btjmLq_certificationBanner",
  "col": "btjmLq_col",
  "constrainWidth": "btjmLq_constrainWidth",
  "contactSection": "btjmLq_contactSection",
  "contentMaxWidth": "btjmLq_contentMaxWidth",
  "designError": "btjmLq_designError",
  "diseaseElementsContainer": "btjmLq_diseaseElementsContainer",
  "diseaseTitle": "btjmLq_diseaseTitle",
  "diseasesContainer": "btjmLq_diseasesContainer",
  "doctorBenefitImage": "btjmLq_doctorBenefitImage",
  "doctorContainer": "btjmLq_doctorContainer",
  "doctorContent": "btjmLq_doctorContent",
  "doctorExplanationTitle": "btjmLq_doctorExplanationTitle",
  "doctorSection": "btjmLq_doctorSection",
  "doctorsExplanationBody": "btjmLq_doctorsExplanationBody",
  "doctorsImage": "btjmLq_doctorsImage",
  "drawer": "btjmLq_drawer",
  "drawerTopBar": "btjmLq_drawerTopBar",
  "expContainer": "btjmLq_expContainer",
  "expImage": "btjmLq_expImage",
  "expText": "btjmLq_expText",
  "expTitle": "btjmLq_expTitle",
  "explanationImage": "btjmLq_explanationImage",
  "explanationSection": "btjmLq_explanationSection",
  "explanationText": "btjmLq_explanationText",
  "explanationTitle": "btjmLq_explanationTitle",
  "flwr": "btjmLq_flwr",
  "footer": "btjmLq_footer",
  "footerBottom": "btjmLq_footerBottom",
  "footerCopyright": "btjmLq_footerCopyright",
  "footerGroup": "btjmLq_footerGroup",
  "footerLink": "btjmLq_footerLink",
  "footerLinks": "btjmLq_footerLinks",
  "imageWrapper": "btjmLq_imageWrapper",
  "innerModal": "btjmLq_innerModal",
  "investorImage": "btjmLq_investorImage",
  "itemsCenter": "btjmLq_itemsCenter",
  "justifyCenter": "btjmLq_justifyCenter",
  "lighttherapyFlex": "btjmLq_lighttherapyFlex",
  "lighttherapyFlexDoctor": "btjmLq_lighttherapyFlexDoctor",
  "link": "btjmLq_link",
  "listItem": "btjmLq_listItem",
  "main": "btjmLq_main",
  "marginBig": "btjmLq_marginBig",
  "marginBottomBigScreen": "btjmLq_marginBottomBigScreen",
  "marginBottomSmallScreen": "btjmLq_marginBottomSmallScreen",
  "marginMiddle": "btjmLq_marginMiddle",
  "marginSmall": "btjmLq_marginSmall",
  "modal": "btjmLq_modal",
  "networkContainerDirection": "btjmLq_networkContainerDirection",
  "networkContent": "btjmLq_networkContent",
  "networkSection": "btjmLq_networkSection",
  "orderProcessStep": "btjmLq_orderProcessStep",
  "pRegularFontSize": "btjmLq_pRegularFontSize",
  "partnerButtonPosition": "btjmLq_partnerButtonPosition",
  "partnerImageContainer": "btjmLq_partnerImageContainer",
  "patientBody": "btjmLq_patientBody",
  "patientContainer": "btjmLq_patientContainer",
  "patientContent": "btjmLq_patientContent",
  "patientTitle": "btjmLq_patientTitle",
  "processContainer": "btjmLq_processContainer",
  "processSteps": "btjmLq_processSteps",
  "processTitle": "btjmLq_processTitle",
  "proximaNova": "btjmLq_proximaNova",
  "root": "btjmLq_root",
  "row": "btjmLq_row",
  "secondArrowRight": "btjmLq_secondArrowRight",
  "sectionEight": "btjmLq_sectionEight",
  "sectionEleven": "btjmLq_sectionEleven",
  "sectionFive": "btjmLq_sectionFive",
  "sectionFiveMarginBottom": "btjmLq_sectionFiveMarginBottom",
  "sectionFour": "btjmLq_sectionFour",
  "sectionMedium": "btjmLq_sectionMedium",
  "sectionSeven": "btjmLq_sectionSeven",
  "sectionSix": "btjmLq_sectionSix",
  "sectionThreePatient": "btjmLq_sectionThreePatient",
  "sectionThreeTitle": "btjmLq_sectionThreeTitle",
  "sectionTwo": "btjmLq_sectionTwo",
  "sectionTwoTitle": "btjmLq_sectionTwoTitle",
  "sizeExperiment": "btjmLq_sizeExperiment",
  "smallImageCol": "btjmLq_smallImageCol",
  "smallImageContainer": "btjmLq_smallImageContainer",
  "spaceAround": "btjmLq_spaceAround",
  "spaceBetween": "btjmLq_spaceBetween",
  "studyContainerDirection": "btjmLq_studyContainerDirection",
  "studyContent": "btjmLq_studyContent",
  "studyImageMargin": "btjmLq_studyImageMargin",
  "tabletArrow": "btjmLq_tabletArrow",
  "teamContainer": "btjmLq_teamContainer",
  "teamGrid": "btjmLq_teamGrid",
  "teamSection": "btjmLq_teamSection",
  "textCenter": "btjmLq_textCenter",
  "therapySetContainer": "btjmLq_therapySetContainer",
  "therapySetContent": "btjmLq_therapySetContent",
  "therapySetImage": "btjmLq_therapySetImage",
  "therapySetText": "btjmLq_therapySetText",
  "therapySetTitle": "btjmLq_therapySetTitle",
  "threeLineEllipse": "btjmLq_threeLineEllipse",
  "wideBox": "btjmLq_wideBox",
  "womanOnChairImage": "btjmLq_womanOnChairImage",
  "youtubeEmbed": "btjmLq_youtubeEmbed",
  "youtubeEmbedContainer": "btjmLq_youtubeEmbedContainer",
});
